<template>
  <Component
    :is="resolveErrorComponent"
    v-bind="errorProps"
  />
</template>

<script lang="ts" setup>
import type { NuxtError } from "#app";

const { error } = defineProps<{
  error: NuxtError;
}>();

const resolveErrorComponent = computed(() => {
  switch (error.statusCode) {
    case 403: {
      return resolveComponent("SharedError403");
    }

    case 404: {
      return resolveComponent("SharedError404");
    }

    case 500: {
      return resolveComponent("SharedError500");
    }

    default: {
      return resolveComponent("SharedError500");
    }
  }
});

const errorProps = computed(() => {
  let parsedData = {};

  if (typeof error.data === "string") {
    try {
      parsedData = JSON.parse(error.data);
    } catch (e) {
      console.error("Failed to parse error.data:", e);
      parsedData = {};
    }
  } else if (error.data && typeof error.data === "object") {
    parsedData = error.data;
  }

  return {
    description: parsedData?.description,
    title: parsedData?.title,
  };
});
</script>
